import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Distinctions from "./components/Distinctions"
import RewardList from "./components/RewardList"
import { useLocation } from "react-router-dom";
import AppTour from "../../../components/AppTour/AppTour";
import { rewardsTourStep } from "../../../components/AppTour/ModuleTourSteps";
import { useFetchAllRewards } from "../../../queries/professoru/forum.query";
import { useTrackFirstVisit, ACTIVITY_TYPES } from "../../../hooks/useTrackFirstVisit";
import { useTrackModuleVisit, MODULE_VISIT_TYPES } from "../../../hooks/useTrackModuleVisit";
import * as billingActions from "../../../redux/actions/billing";

const Rewards = () => {
    const {hash} = useLocation()
    const dispatch = useDispatch();
    const [runTour, setRunTour] = useState(false)
    const { data: rewardsData, isPending } = useFetchAllRewards({ refetchOnMount: 'always' });

    useTrackFirstVisit(ACTIVITY_TYPES.PROFESSORU_REWARDS_FIRST_VISIT);
    useTrackModuleVisit(MODULE_VISIT_TYPES.PROFESSORU, "rewards");

    useEffect(() => {
        if(hash === "#start-tour"){
            setRunTour(true)
        }
    }, [hash])

    useEffect(() => {
        dispatch(billingActions.getBillingDetails());
        dispatch(billingActions.getUserPurchases({}, 'all'));
    }, [dispatch]);
    return(
        <div className="DataAnalyst-page py-5">
            <AppTour
                tourSteps={rewardsTourStep}
                runTour={runTour}
                setRunTour={setRunTour}
                tourName="professoru-rewards"
                moduleId="professoru-rewards"
            />
            <div className="container max-w-full">
                <Distinctions
                    title={"Rewards"}
                    inputPlaceholder={"What do you want to achieve right now?"}
                    rewardsButton={false}
                    rewardsData={rewardsData}
                />
            </div>
            <div data-tour="rewards-list">
                <RewardList rewardsData={rewardsData} isLoading={isPending}/>
            </div>
        </div>
    )
}

export default Rewards